export default {
  // 判断是否是微信浏览器
  isWechat() {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true
    } else {
      return false
    }
  },

  isIOS() {
    var ua = window.navigator.userAgent
    return /iPhone|iPad|iPod/i.test(ua)
  },

  isAndroid() {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.indexOf('android') > -1 || ua.indexOf('linux') > -1) {
      return true
    } else {
      return false
    }
  },

  /**
   * 删除url中指定的参数
   * @param {} name 参数名
   */
  removeUrlParam(originUrl, name) {
    var arr = originUrl.split('?')
    if (arr.length > 1) {
      var baseUrl = arr[0]
      var query = arr[1]
      if (query.indexOf(name) > -1) {
        var obj = {}
        var array = query.split('&')
        for (var i = 0; i < array.length; i++) {
          array[i] = array[i].split('=')
          obj[array[i][0]] = array[i][1]
        }
        delete obj[name]
        var url = ''
        if (JSON.stringify(obj) === '{}') {
          url = baseUrl
        } else {
          url = baseUrl + '?' + JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&')
        }
        return url
      } else {
        return originUrl
      }
    } else {
      return originUrl
    }
  },

  // 获取随机字符串
  getRandomStr(min, max) {
    var returnStr = "",
      range = (max ? Math.round(Math.random() * (max - min)) + min : min),
      charStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (var i = 0; i < range; i++) {
      var index = Math.round(Math.random() * (charStr.length - 1));
      returnStr += charStr.substring(index, index + 1);
    }
    return returnStr;
  },

  // json按key排序
  jsonSort(jsonObj) {
    let arr = [];
    for (var key in jsonObj) {
      arr.push(key)
    }
    arr.sort();
    let str = '';
    for (var i in arr) {
      str += arr[i] + "=" + jsonObj[arr[i]] + "&"
    }
    return str.substr(0, str.length - 1)
  },


}
/***
* 获得本周起止时间
*/
export function getWeekStartAndEndDates(format) {
  const currentDate = new Date();
  const dayOfWeek = currentDate.getDay();

  const startOfWeek = new Date(currentDate);
  startOfWeek.setDate(currentDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));

  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(endOfWeek.getDate() + 6);

  return {
      start: formatDate(startOfWeek, format),
      end: formatDate(endOfWeek, format),
  };

  function formatDate(date, format) {
      switch (format) {
          case 'iso':
              return date.toISOString();
          case 'locale':
              const options = { timeZone: 'UTC', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
              return date.toLocaleDateString(undefined, options);
          case 'yyyy-mm-dd':
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的，所以需要加1并补零
              const day = String(date.getDate()).padStart(2, '0');
              return `${year}-${month}-${day}`;
          default:
              throw new Error(`Unsupported format: ${format}`);
      }
  }
}



// WEBPACK FOOTER //
// ./src/util/util.js